import {uploadFileToS3} from '@sollapay/web-core';

import type {HttpClient} from '@sollapay/http-client';
import type {
  ApiResponse,
  FirmProfileDTO,
  LogoUploadUrlDTO,
  LogoUploadUrlPayload,
  UpdateFirmProfilePayload
} from '@sollapay/types';

export const firmSettingsApi = {
  fetchProfile: async (client: HttpClient): Promise<ApiResponse<FirmProfileDTO>> =>
    client.get<ApiResponse<FirmProfileDTO>>('/firm/profile'),

  updateProfile: async (
    client: HttpClient,
    payload: UpdateFirmProfilePayload
  ): Promise<ApiResponse<FirmProfileDTO>> =>
    client.patch<ApiResponse<FirmProfileDTO>, UpdateFirmProfilePayload>('/firm/profile', payload),

  createLogoUploadUrl: async (
    client: HttpClient,
    payload: LogoUploadUrlPayload
  ): Promise<ApiResponse<LogoUploadUrlDTO>> =>
    client.post<ApiResponse<LogoUploadUrlDTO>, LogoUploadUrlPayload>(
      '/firm/logo/upload-url',
      payload
    ),

  uploadLogoToS3: uploadFileToS3
};
